/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { subscriptionIndex } from '../../axios/subscriptionIndex'
import type {
	SubscriptionIndexError,
	SubscriptionIndexPathParams,
	SubscriptionIndexResponse,
} from '../../types/SubscriptionIndex'

export const subscriptionIndexQueryKey = (organisation: SubscriptionIndexPathParams['organisation']) =>
	[{ url: '/:organisation/subscription', params: { organisation } }] as const

export type SubscriptionIndexQueryKey = ReturnType<typeof subscriptionIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::index */
export function subscriptionIndexQueryOptions(
	organisation: SubscriptionIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		SubscriptionIndexResponse,
		AxiosError<SubscriptionIndexError>,
		SubscriptionIndexResponse,
		SubscriptionIndexQueryKey
	>({
		queryKey: subscriptionIndexQueryKey(organisation),
		queryFn: ({ signal }) => subscriptionIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::index */
export function useSubscriptionIndex<TSelectData = SubscriptionIndexResponse>(
	organisation: SubscriptionIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					SubscriptionIndexResponse,
					AxiosError<SubscriptionIndexError>,
					TSelectData,
					SubscriptionIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<SubscriptionIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...subscriptionIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::index */
export function useSubscriptionIndexSuspense<TSelectData = SubscriptionIndexResponse>(
	organisation: SubscriptionIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					SubscriptionIndexResponse,
					AxiosError<SubscriptionIndexError>,
					TSelectData,
					SubscriptionIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<SubscriptionIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...subscriptionIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
